import { render, staticRenderFns } from "./VericalLayout.vue?vue&type=template&id=200693d4&scoped=true"
import script from "./VericalLayout.vue?vue&type=script&lang=js"
export * from "./VericalLayout.vue?vue&type=script&lang=js"
import style0 from "./VericalLayout.vue?vue&type=style&index=0&id=200693d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200693d4",
  null
  
)

export default component.exports